import { render, staticRenderFns } from "./RedCoinList.vue?vue&type=template&id=0579651e&scoped=true&"
import script from "./RedCoinList.vue?vue&type=script&lang=js&"
export * from "./RedCoinList.vue?vue&type=script&lang=js&"
import style0 from "./RedCoinList.vue?vue&type=style&index=0&id=0579651e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0579651e",
  null
  
)

export default component.exports